import React from 'react'

type PropsT = {
  className?: string
  fillColor?: string
}

const NoLocationsIcon: React.FC<PropsT> = ({
  className,
  fillColor = '#9E9E9E',
}) => (
  <svg
    className={className}
    width="80"
    height="68"
    viewBox="0 0 126 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.1749 0C43.0191 0 26.7504 16.504 26.7504 36.6273C26.7504 57.4745 38.412 74.992 48.202 85.9946H25.8866C25.5987 85.9946 25.3107 86.1394 25.0228 86.2842L0.547816 105.394C0.115905 105.828 -0.172036 106.408 0.115905 106.987C0.403846 107.566 0.835757 108 1.41164 108H41.7233H84.3386H84.4825H124.65C125.226 108 125.802 107.566 125.946 106.987C126.09 106.408 125.946 105.684 125.514 105.394L101.327 86.429C101.039 86.2842 100.751 86.1394 100.463 86.1394H78.2918C88.0818 75.1367 99.7434 57.6193 99.7434 36.7721C99.7434 16.504 83.3308 0 63.1749 0ZM96.2881 36.222C96.2881 66.1802 70.542 89.9614 63.2525 95.9839C55.9629 89.9614 30.0617 66.1802 30.0617 36.222C30.0617 18 44.951 3.32976 63.0974 3.32976C81.2437 3.32976 96.2881 18.1544 96.2881 36.222ZM50.7935 89.0349H50.0736L43.8829 105.105H82.323L76.1323 89.0349H75.5564C71.0994 93.6315 67.2775 96.7687 65.6747 98.0844C65.2583 98.4262 64.9916 98.645 64.9026 98.7346C64.3267 99.1689 63.7508 99.3137 63.1749 99.3137C62.599 99.3137 62.0232 99.1689 61.4473 98.7346C60.8714 98.445 56.4083 94.9705 50.7935 89.0349ZM47.0502 89.0349L40.8595 105.105H5.73075L26.4625 89.0349H47.0502ZM79.2996 89.0349L85.4903 105.105H120.763L100.031 89.0349H79.2996Z"
      fill={fillColor}
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.7841 25.6159C78.2296 25.0614 77.3334 25.0614 76.7789 25.6159L70.5489 31.8459C68.6288 30.3526 66.2222 29.4549 63.6 29.4549C57.3346 29.4549 52.2548 34.5347 52.2548 40.8002C52.2548 43.4224 53.1525 45.829 54.6458 47.7492L48.4159 53.9792C47.8614 54.5337 47.8614 55.43 48.4159 55.9845C48.6924 56.261 49.0555 56.4 49.4185 56.4C49.7816 56.4 50.1446 56.261 50.4211 55.9845L56.6511 49.7545C58.5727 51.2478 60.9778 52.1455 63.6 52.1455C69.8654 52.1455 74.9452 47.0656 74.9452 40.8002C74.9452 38.178 74.0475 35.7728 72.5542 33.8512L78.7841 27.6212C79.3386 27.0667 79.3386 26.1704 78.7841 25.6159ZM55.0911 40.8002C55.0911 36.1075 58.9073 32.2912 63.6 32.2912C65.4351 32.2912 67.1312 32.8812 68.5224 33.8724L56.6723 45.7226C55.6811 44.3314 55.0911 42.6353 55.0911 40.8002ZM63.6 49.3092C68.2927 49.3092 72.1089 45.4929 72.1089 40.8002C72.1089 38.9651 71.5189 37.269 70.5277 35.8777L58.6776 47.7279C60.0688 48.7192 61.7649 49.3092 63.6 49.3092Z"
      fill={fillColor}
    />
  </svg>
)

export default NoLocationsIcon
